<template>
  <OrganismLogout/>
</template>

<script>
export default {
  name: 'Logout',

  components: {
    OrganismLogout: () => import('@/components/organisms/OrganismLogout')
  },

  mounted () {
    this.$auth.logout()
  }
}
</script>
